export default __webpack_public_path__ + "static/media/specialty-stat-icon.475b72c1.svg";